import React from 'react'
import {ImportCollectionComp} from 'components'
const ImportCollection = () => {
  return (
    <div><ImportCollectionComp/></div>
  )
}

export default ImportCollection